<template>
  <div class="mine">
    <div style="margin: 0 20px;">
      <div class="mine_headers">
        <tabs :tabs-list="tabsList" @tabs="handleTabChange" />
        <div class="date_box">
          <search :model="model" @changeDate="changeDate" :search-list="searchList" />
        </div>
      </div>
    </div>
    <!-- 公共表格 -->
    <div class="table_box">
      <el-table
        ref="table"
        :data="tableData"
        :span-method="objectSpanMethod"
        highlight-current-row
        class="scpc-task-table"
        border
        height="100%"
        :header-cell-style="{
          background: '#F1F1F1 ',
          fontSize: '14px',
          color: '#999999'
        }"
        :cell-style="{
          fontSize: '14px',
        }"
        :row-style="{ height: '38px' }"
        :style="{
          width: '100%'
        }"
        v-el-table-infinite-scroll="loadList"
        :infinite-scroll-distance="50"
      >
        <!-- 动态列配置 -->
        <el-table-column
          v-for="(column, index) in tableColumns"
          :key="column.prop || index"
          :prop="column.prop"
          :label="column.label"
          :min-width="column.width"
        >
          <!-- 内容 -->
          <template slot-scope="scope">
            <span style="white-space: pre-wrap;">{{scope.row[column.prop]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import tabs from './tabs.vue'
import search from './search.vue'
import { wxConfig } from '../../../utils/wxConfig'
import { getMenuConfig, getSearchList, getTableData } from '../../../utils/api/jierun'
export default {
  components: {
    tabs, search
  },
  data() {
    return {
      tabsList: [
        {
          paneName: 'monthFinish',
          label: '项目进度'
        },
        {
          paneName: 'monthArchive',
          label: '归档查询'
        },
        {
          paneName: 'weekFinish',
          label: '完成查询'
        },
        {
          paneName: 'monthPlan',
          label: '下月计划'
        },
        {
          paneName: 'weekPlan',
          label: '下周计划'
        }
      ],
      model: 'test_month_complete',
      value1: '',
      channel: JSON.parse(sessionStorage.getItem('loginUserData') || '{}').channel,
      page: 1,
      pageSize: 40,
      pageNum: 0,
      activeTab: {
        paneName: 'monthFinish',
        label: '本月完成'
      },
      tableData: [],
      tableColumns: [],
      searchList: [],
      loading: false,
      isFirstLoad: false
    }
  },
  watch: {
    tableData: {
      deep: true,
      handler: function() {
        this.updateTableLayout()
      }
    },
    tableColumns: {
      deep: true,
      handler: function() {
        this.updateTableLayout()
      }
    },
    model: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchTabData()
        }
      }
    }
  },
  mounted() {
    if (this.channel === 'wechat') {
      wxConfig()
      setTimeout(() => {
        // this.getUserKPIList()
      }, 500)
    } else {
      // this.getUserKPIList()
    }
  },
  methods: {
    updateTableLayout() {
      this.$nextTick(() => {
        const doLayout = () => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout()
          }
        }
        doLayout()
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(doLayout)
        }
        setTimeout(doLayout, 100)
      })
    },
    // 核心修复：等待表头和查询条件都加载完成后，再获取表格数据
    fetchTabData() {
      if (this.loading) return
      this.loading = true
      // 清空旧数据，避免视觉混淆
      this.tableData = []
      this.tableColumns = []
      this.searchList = []

      Promise.all([
        this.getMenuConfig(),
        this.getSearchList()
      ]).then(() => {
        // 两个接口都完成后，再执行表格数据请求
        return this.getTableData()
      }).finally(() => {
        this.loading = false
        this.isFirstLoad = true
        this.updateTableLayout()
      })
    },
    // 获取表头（移除内部的getTableData调用）
    getMenuConfig() {
      const params = {
        model: this.model
      }
      return getMenuConfig(params).then((data) => {
        if (data.code === 10000) {
          this.tableColumns = data.result
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取表头失败：', error)
        throw error // 抛出错误，让Promise.all捕获
      })
    },
    // 获取查询条件
    getSearchList() {
      const params = {
        model: this.model
      }
      return getSearchList(params).then((data) => {
        if (data.code === 10000) {
          this.searchList = data?.result || []
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取查询条件失败：', error)
        throw error // 抛出错误，让Promise.all捕获
      })
    },
    // 获取表格数据
    getTableData() {
      // 增加空值保护
      if (!this.model) return

      const page = this.page
      const pageSize = this.pageSize
      const searchData = this.searchList.map(item => {
        const result = {}
        const propKey = item.prop
        // 判断type为10或11，提取id数组
        if (item.type === '10' || item.type === '11') {
          // 兜底防止 defaultValue 非数组报错
          const idArr = Array.isArray(item.defaultValue)
            ? item.defaultValue.map(ele => ele.id)
            : []
          result[propKey] = idArr
        } else {
          // 其他类型直接赋值原值
          result[propKey] = item.defaultValue
        }
        return result
      })
      const date = {
        model: this.model,
        searchData: searchData
      }
      return getTableData(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          this.tableData = data.result.list
          this.pageNum = data.result.pages
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log('获取表格数据失败：', error)
      }).finally(() => {
        this.updateTableLayout()
        // 关闭临时loading
      })
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const currentColumn = this.tableColumns[columnIndex]
      if (currentColumn && currentColumn.margeFlag === '1') {
        const currentValue = row.projectId
        const previousValue = rowIndex > 0 ? this.tableData[rowIndex - 1].projectId : ''

        if (currentValue === previousValue) {
          return [0, 0]
        } else {
          let count = 1
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].projectId === currentValue) {
              count++
            } else {
              break
            }
          }
          return [count, 1]
        }
      }
    },
    // 修改时间
    changeDate(list) {
      console.log(list, '获取查询条件')
      this.searchList = this.searchList.map((item) => {
        if (item.type === list.type) {
          return {
            ...item,
            defaultValue: list.defaultValue
          }
        }
        return item
      })
      // 重置页码，重新加载第一页
      this.page = 1
      this.getTableData()
    },
    // 无限滚动
    loadList() {
      if (this.loading) return // 防止重复加载
      if (this.pageNum > this.page) {
        this.page += 1
        this.getTableData1()
      }
    },
    getTableData1() {
      this.loading = true
      const page = this.page
      const pageSize = this.pageSize
      const searchData = this.searchList.map(item => {
        const result = {}
        const propKey = item.prop
        // 判断type为10或11，提取id数组
        if (item.type === '10' || item.type === '11') {
          // 兜底防止 defaultValue 非数组报错
          const idArr = Array.isArray(item.defaultValue)
            ? item.defaultValue.map(ele => ele.id)
            : []
          result[propKey] = idArr
        } else {
          // 其他类型直接赋值原值
          result[propKey] = item.defaultValue
        }
        return result
      })
      const date = {
        model: this.model,
        searchData: searchData
      }
      getTableData(page, pageSize, date).then((data) => {
        if (data.code === 10000) {
          this.tableData = [...this.tableData, ...data.result.list]
          this.pageNum = data.result.pages
        } else {
          this.$message.error(data.info)
        }
      }).catch((error) => {
        console.log(error)
      }).finally(() => {
        this.loading = false
        this.updateTableLayout()
      })
    },
    // 切换标签页
    handleTabChange(tab) {
      this.activeTab = tab
      this.page = 1 // 重置页码
      switch (tab.paneName) {
        case 'monthFinish':
          this.model = 'test_month_complete'
          break
        case 'monthPlan':
          this.model = 'test_month_plan'
          break
        case 'weekFinish':
          this.model = 'test_week_complete'
          break
        case 'weekPlan':
          this.model = 'test_week_plan'
          break
        case 'monthArchive':
          this.model = 'test_month_archive'
          break
      }
      this.updateTableLayout()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/index.scss';
.mine {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .mine_headers{
    flex-shrink: 0;
    margin: 12px 0 15px;
    width: 100%;
    // display: flex;
    // align-items: center;
    // justify-content: space-between;
  }
  .date_box{
    text-align: left;
  }
}
.table_box{
  flex: 1;
  min-height: 0;
  width: calc(100% - 34px);
  margin-left: 15px;
  overflow: hidden;
}
::v-deep .el-tabs__nav-scroll{
  padding: 0 40px 0 0 !important;
}
::v-deep .el-tabs{
  width: 100% !important;
}
::v-deep .scpc-task-table{
  height: 100% !important;
}
::v-deep .scpc-task-table .el-table__body-wrapper{
  overflow: auto !important;
}
::v-deep .el-table .cell{
  min-width: 0;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
  height: auto !important;
  line-height: normal !important;
  padding: 10px !important
}

</style>
